export const getComponentName = (componentStack) => {
  return componentStack?.split(' ')
    ?.find((line) => line.includes(':'))
    ?.match(/([^(]+):/)?.[1]
    || '';

};
